import { render, staticRenderFns } from "./VehicleRequestDetail.vue?vue&type=template&id=7c13cf57&"
import script from "./VehicleRequestDetail.vue?vue&type=script&lang=js&"
export * from "./VehicleRequestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports